// extracted by mini-css-extract-plugin
export var loadingSpinner = "_2a-0";
export var spinnerContainer = "_2a-1";